import React from 'react';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

const CheckoutCancel = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-red-500" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Pago Cancelado</h1>
        <p className="text-gray-600 mb-6">
          Tu pago ha sido cancelado. No se ha realizado ningún cargo a tu tarjeta.
        </p>
        
        <div className="space-y-3">
          <Button 
            onClick={() => window.location.href = '/#calculator'}
            className="w-full bg-cyan-600 hover:bg-cyan-700"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Intentar de Nuevo
          </Button>
          
          <Button 
            variant="outline"
            onClick={() => window.location.href = '/'}
            className="w-full"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Volver al Inicio
          </Button>
        </div>

        <div className="mt-8 pt-6 border-t">
          <p className="text-sm text-gray-500">
            ¿Necesitas ayuda? Contáctanos:
          </p>
          <p className="text-sm font-medium text-gray-700">
            561-310-5774 | 561-568-7620
          </p>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancel;
